import { gql } from "@apollo/client";

const GetAllCoupons = gql`
query GetCoupons($limit: Int) {
  user_coupons(order_by: {id: desc}, limit: $limit) {
    coupon_code
    coupon_links
    coupon_code_gen2
    id
    created_at
    validity
    coupon {
      brand_logo
      brand_name
      terms
      status
      offer_type
      offer_title
      offer_subtitle
      name
      mode
      merchant_id
      location
      industry
      industry_name
      id
      expiry_date
      coupon_code
      color
      code_type
    }
    redeemed
  }
}
`;
export default GetAllCoupons;
